import React from "react";
import { UtensilsCrossed, Footprints, Smartphone, PackageCheck } from "lucide-react";

const STEPS = [
  {
    n: "01",
    icon: UtensilsCrossed,
    title: "Pick Your Brand",
    body: "Browse all twenty resident brands above. Tap into the cuisine you're craving — Detroit pizza, ramen, peri peri, parathas, and more.",
  },
  {
    n: "02",
    icon: Footprints,
    title: "Walk In & Order",
    body: "Come straight to the counter at our Edinburgh hub. Order from one brand or mix dishes across many — all in a single order.",
  },
  {
    n: "03",
    icon: Smartphone,
    title: "Or Order Online",
    body: "Open Just Eat, Deliveroo, Uber Eats or Panda. Find the brand, build your basket and check out in the app you already know.",
  },
  {
    n: "04",
    icon: PackageCheck,
    title: "Collect or Delivered",
    body: "Grab it at the counter in minutes, or wait for the rider to bring it warm to your door. Either way — eat well.",
  },
];

export default function HowItWorks() {
  return (
    <section id="how" className="py-20 lg:py-28 bg-[var(--surface)]" data-testid="how-section">
      <div className="container-nk">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div>
            <p className="eyebrow">// How It Works</p>
            <h2 className="font-display text-[56px] md:text-[80px] leading-[0.95] mt-3">
              Four Steps.<br />Then You Eat.
            </h2>
          </div>
          <p className="text-muted text-[15px] max-w-md font-light leading-relaxed">
            However you order, the path from craving to first bite stays
            satisfyingly short.
          </p>
        </div>

        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
          {STEPS.map((s) => {
            const Icon = s.icon;
            return (
              <div
                key={s.n}
                className="step-card"
                data-testid={`how-step-${s.n}`}
              >
                <span className="step-num">{s.n}</span>
                <Icon size={26} className="text-gold relative z-10" />
                <h4 className="font-display text-[28px] mt-5 relative z-10">
                  {s.title}
                </h4>
                <p className="text-[14px] text-[var(--text)]/70 mt-3 font-light leading-relaxed relative z-10">
                  {s.body}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
